import {
	Avatar,
	List,
	ListItem,
	ListItemAvatar,
	ListItemText,
	Typography,
	useTheme,
} from '@mui/material';
import {Drawer} from 'presentation/components/Drawer';
import {HandleMessage} from 'presentation/components/HandleMessage';
import React, {useEffect, useState} from 'react';
import {detect} from 'detect-browser';
import {translations} from 'presentation/translations-new';
import {useMediaQueries} from 'presentation/pages/private';
import {InstructionsProps} from './types';
import {BrowserName, OperatingSystem} from './constants';

const {chrome, chromeMobile, firefox, firefoxMobile, safari, safariMobile} =
	translations['pt-br'].privateFlow.bookingFlow.location.instructions;
const {locationPermissionDenied, locationPermissionInstructions, manualSelection} =
	translations['pt-br'].privateFlow.bookingFlow.location;

const Instructions = ({
	open,
	onOpen,
	onClose,
	onManualSelection,
	closeButtonDataTagId,
}: InstructionsProps) => {
	const {palette} = useTheme();
	const [instructionsState, setInstructionsState] = useState<string[]>([]);
	const {isMobile} = useMediaQueries();

	const getRightMessage = () => {
		const browser = detect();

		const isIOS = browser?.os === OperatingSystem.IOS;
		const isAndroid = browser?.os === OperatingSystem.ANDROID;
		const isAndroidOrIOS = isIOS || isAndroid;

		if (isAndroidOrIOS && isMobile) {
			switch (browser?.name) {
				case BrowserName.FIREFOX:
					return firefoxMobile;
				case BrowserName.SAFARI:
					return safariMobile;
				default:
					return chromeMobile;
			}
		}

		switch (browser?.name) {
			case BrowserName.FIREFOX:
				return firefox;
			case BrowserName.SAFARI:
				return safari;
			default:
				return chrome;
		}
	};
	useEffect(() => {
		setInstructionsState(getRightMessage());
	}, []);

	return (
		<Drawer.Root open={open} onClose={onClose} onOpen={onOpen} width={'685px'}>
			<Drawer.Header onClose={onClose} title={locationPermissionDenied} />
			<Drawer.Content>
				<Typography variant="body1" fontWeight={600} sx={{my: 2}}>
					{locationPermissionInstructions}
				</Typography>
				<List sx={{p: 0}}>
					{instructionsState.map((item, idx) => (
						<ListItem key={idx} sx={{px: 0}}>
							<ListItemAvatar sx={{minWidth: 32}}>
								<Avatar sx={{bgcolor: palette.primary.main, width: 24, height: 24}}>
									<Typography fontSize={14} fontWeight={600}>
										{idx + 1}
									</Typography>
								</Avatar>
							</ListItemAvatar>
							<ListItemText primary={<HandleMessage message={item} />} />
						</ListItem>
					))}
				</List>
			</Drawer.Content>
			<Drawer.Footer
				firstButtonDataTagId={closeButtonDataTagId}
				firstButtonTitle={manualSelection}
				firstButtonOnClick={onManualSelection}
				hideSecondButton
			/>
		</Drawer.Root>
	);
};

export {Instructions};
